module.exports = __webpack_public_path__ + "static/media/reg_tabQRCode_show.8b6bfb5c.svg";